module.exports = __webpack_public_path__ + "img/delivery1_3.d5408abe.png";